export default __webpack_public_path__ + "static/media/book_appointment.0c2ce511.svg";